import { BusMessage, calcStringByteLength, MessageFactory, UID_BYTES_PER_ELEMENT } from "flavr-common";
import { calcFileIdByteLength, serializationFileId } from "../../modules/files/FileTypes";
/**
 * Requests taking a camera snapshot.
 */
export class RequestCameraTakeSnapshotMessage extends BusMessage {
    get byteLength() {
        return UID_BYTES_PER_ELEMENT;
    }
    constructor(uid) {
        super();
        this.uid = uid;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
    }
    static is(msg) {
        return msg.type === RequestCameraTakeSnapshotMessage.typestatic;
    }
}
RequestCameraTakeSnapshotMessage.typestatic = "RequestCameraTakeSnapshotMessage";
RequestCameraTakeSnapshotMessage.subjectstatic = "general";
MessageFactory.register(RequestCameraTakeSnapshotMessage);
/**
 * Returns the result of taking a camera snapshot.
 */
export class ResponseCameraTakeSnapshotMessage extends BusMessage {
    get byteLength() {
        return (UID_BYTES_PER_ELEMENT + // uid
            calcFileIdByteLength(this.fileId) + // fileId
            calcStringByteLength(this.imageUrl));
    }
    constructor(uid, fileId, imageUrl) {
        super();
        this.uid = uid;
        this.fileId = fileId;
        this.imageUrl = imageUrl;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.fileId = serializationFileId(stream, this.fileId);
        this.imageUrl = stream.utf16String(this.imageUrl);
    }
    static is(msg) {
        return msg.type === ResponseCameraTakeSnapshotMessage.typestatic;
    }
}
ResponseCameraTakeSnapshotMessage.typestatic = "ResponseCameraTakeSnapshotMessage";
ResponseCameraTakeSnapshotMessage.subjectstatic = "general";
MessageFactory.register(ResponseCameraTakeSnapshotMessage);
